
import React, { PureComponent, useContext, useEffect, useRef, useState, } from 'react';
import {Table, Input,  Form, message, Tooltip} from 'antd';
import Lang from "@components/Lang/Lang";
import {isEmpty,toFixed2,formatNumberToPrice} from '@utils/utils';
import AutoFetchTableService from "../AutoFetchTable/AutoFetchTable.action";
import "./Index.less";
import dayjs from "dayjs";
import PropTypes from "prop-types";
const { createContext } = React;
const FormItem = Form.Item;
const EditableContext = createContext(null);
const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

/** EditTable
 * by 2022.09.19 搜索可直接编辑数据表格
 * columns 栏目
 如：  {
                    title: '国际化名',
 *                  cnTitle：lang的默认显示值
 *                  cnTitleId: lang 对应KEY
                    dataIndex: 'i18nName',
                    key: 'i18nName',
                    editable: true,  配置此项则可编辑
                    required: true, 配置此项则必填
                },
 * handleGetAllList 回调当前所有行
 * getRowData 单元格编辑结束时 回调行数据项方法  ---> 暂定离开编辑表格时触发 TODO
 * onRef handleFetch 调用此方法重新获取数据
 *
 * initFetch 进入是否查询 默认为true
 * fetchCondition 搜索条件
 * footer 底部 默认否
 * size 尺寸
 * rowClassName 表格行类名
 * scroll 滚动配置
 * paginationFlag 是否显示页码 true
 *
 *  ----下列 未配置 未测试-----
 * rowSelection 选择行 默认null
 *
 * 显示相关
 * type 显示类型
 **/
const EditableCell = ({
                          title,
                          editable,
                          children,
                          dataIndex,
                          record,
                          handleSave,
                          editType,
                          required,
                          ...restProps
                      }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);
    // 复制
    const handleCopy = (sValue)=>{
        const input = document.createElement('input');
        input.value = sValue;//将需要复制的内容赋值给input框
        document.body.appendChild(input);
        input.select()//选中输入框
        document.execCommand('Copy')//复制当前选中文本到前切板
        console.log('复制成功',sValue);
        document.body.removeChild(input);
    }
    /**
     * 粘贴动作
     * */
    const savePastData = async(resStatus) => {
        const values = await form.validateFields();
        let newValues = {...record,...values}
        form.setFieldsValue({
            [dataIndex]:resStatus,
        });
        newValues[dataIndex] = resStatus
        handleSave(newValues);
    }
    const handlePaste = () =>{
        // 查看当时是否有权限
        navigator.permissions.query({
            name:'clipboard-read'
        }).then((permissionsStatus)=>{
            if(permissionsStatus.state=='granted'){ //有权限
                navigator.clipboard.readText().then( (resStatus)=>{
                    savePastData(resStatus)
                });
            }else if(permissionsStatus.state=='prompt'){ //询问权限
                navigator.clipboard.readText().then((resStatus)=>{
                    savePastData(resStatus)
                });
            }else { //禁止状态
                // const agent = document.getElementById(inputId);
                // agent.focus();
                message.info(Lang({
                    id:'DangQianLiuLanQiBuZhiChiZhanTieHangWei,QingShiYong ctrl+v',
                    default:'当前浏览器不支持粘贴行为,请使用ctrl+v'})
                )
            }
        })
    }
    const toggleEdit = () => {
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
        if(!editing)setEditing(!editing);
    };
    const getInput = (sType,isRequired=false,value) =>{
        let input = ''
        switch (sType) {
            case 'CopyAndPasteInput':
                input = (<div className={"flex-item"} ref={inputRef} >
                    <div className={"width-20"}>
                        <Tooltip placement="leftTop" title={Lang({id: 'FuZhi',default:'复制'})}>
                            <span className="icon iconfont icon-tiezhiguanli" onClick={()=>handleCopy(value)}></span>
                        </Tooltip>
                        <Tooltip placement="leftTop" title={Lang({id: 'ZhanTie',default:'粘贴'})}>
                            <span className="icon iconfont icon-hetongguanli" onClick={()=>handlePaste()}></span>
                        </Tooltip>
                    {/*<Popover content={Lang({id: 'ZhanTie',default:'粘贴'})}>*/}
                        {/*<span className="icon iconfont icon-hetongguanli" onClick={()=>handlePaste()}></span>*/}
                    {/*</Popover>*/}
                    </div>
                    <FormItem style={{
                        margin: 0,
                    }} name={dataIndex}
                              rules={[
                                   {
                                       required: isRequired,
                                       message: `${title}`,
                                   },
                               ]}
                    >
                        <Input.TextArea rows={2} onPressEnter={save} onBlur={save} />
                    </FormItem>
                </div>)
                break;
            default:
                input = (<FormItem
                    style={{
                        margin: 0,
                    }}
                    name={dataIndex}
                    rules={[
                        {
                            required: isRequired,
                            message: `${title}`,
                        },
                    ]}
                >
                    <Input ref={inputRef} onPressEnter={save} onBlur={save} />
                </FormItem>)
                break
        }
        return input;
    }
    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };

    let childNode = children;

    if (editable) {
        childNode = editing ? getInput(editType,required,record[dataIndex]) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }

    return <td {...restProps}>{childNode}</td>;
};

class EditTable extends PureComponent{
    static propTypes = {
        columns: PropTypes.array.isRequired,
        fetchFunction: PropTypes.func,
        onRef: PropTypes.func,
        initFetch: PropTypes.bool,
        fetchCondition: PropTypes.object,
        footer: PropTypes.func,
        size: PropTypes.string,
        rowClassName: PropTypes.string,
        rowSelection: PropTypes.any,
        scroll: PropTypes.object,
        paginationFlag: PropTypes.bool,
        getRowData:PropTypes.func,
    }
    static defaultProps = {
        columns: [],
        initFetch: true,
        fetchCondition:{},
        size:'default',
        rowClassName:'editable-row',
        rowSelection: null,
        scroll: { y: 'auto'},
        paginationFlag: true,
    };

    constructor(props) {
        super(props);
        this.state = {
            list:[],
            columns: props.columns,
            current: props.current ? props.current : 1,
            pagination: props.pagination ? props.pagination : {},
            reload:false,
            loading: false,
            size: props.size,
            rowClassName: props.rowClassName,
            lastSearch: {}, //上一次的搜索条件
        }
    }
    /**
     * 行编保存事件
     * @param row
     */
     handleSave = (row) => {
         const {list} = this.state;
        const newData = [...list];
        const index = newData.findIndex((item) => row.id === item.id);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        this.setState({
            list: newData
        })
    };
    /**
     * 切换页面
     * @param pagination 页码数据
     * @param filters 筛选
     * @param sorter  排序
     */
    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        const { lastSearch } = this.state; //点击页面带当前搜索条件
        this.setState({
            pagination: pager,
        },()=> this.fetch(pagination.current,lastSearch));
    }
    /**
     * 查询并加载数据
     * @param params  查询参数
     * @param flagUseLastSearch  是否采用上次的搜索条件
     */
    handleFetch = (pageIndex=1,params = {}, flagUseLastSearch = false) => {
        this.loading(true)
        if(flagUseLastSearch){
            const { lastSearch } = this.state;
            params = { ...lastSearch}
        }else {
            this.setState({
                lastSearch : params
            })
        }
        this.fetch(pageIndex, params)
    }
    /**
     * 搜索
     * @param pageIndex 页码
     * @param fetchCondition 条件
     */
    fetch(pageIndex=1,fetchCondition={}){
        this.loading(true);
        const { fetchApi,precondition} = this.props;
        const { pagination:{pageSize},} = this.state;
        let newSearchMap = {...precondition,...fetchCondition};
        for(let key in newSearchMap){
            if(isEmpty(newSearchMap[key])) delete newSearchMap[key];
        }
        if(this.props.specialHandle){
            const newL = this.props.specialHandle(newSearchMap);
            newSearchMap={...newSearchMap,...newL}
        }
        AutoFetchTableService.fetch(fetchApi,pageSize, pageIndex,newSearchMap).then((resp)=>this.handleRes(resp.data,pageIndex,fetchCondition)).catch(err=>this.handleRes(err));
    }
    handleRes(res={},pageIndex=1,fetchCondition={}){
        const {success,valid,models,paging} = res;
        if (success && valid) {
            const { callBackFields} = this.props;
            const resList = callBackFields&&callBackFields.length>0?this.getResList(res,callBackFields):[...models];
            if(resList.length>0){
                const {pagination,} = this.state;
                let newPageCog = {...pagination};
                this.setState({
                    list: resList,
                    pagination:{
                        ...newPageCog,
                        total: paging&&paging.total?paging.total:resList.length,
                        pageSize:  paging&&paging.total?paging.pageSize:null,
                        current: paging&&paging.pageNum?paging.pageNum:1
                    },
                    lastSearch:fetchCondition
                },()=>{
                    window.scrollTo(0, 0)
                });
            }else this.resetList(fetchCondition);
            if(this.props.fetchCallBack)this.props.fetchCallBack(res)
        }else {
            this.resetList(fetchCondition);
            if(res.message)message.error(res.message);
        }
        this.loading(false);
    }
    getResList(res={},resMap=[]){
        let list={...res};
        resMap.forEach(key=>{
            list =  list[key]
        })
        if(list&&list.constructor!=Array){
            return [list]
        }else return list
    }
    /**
     * 模拟接口
     * 提供父组件 调用获取所有列
     * */
    handleGetAllList(){
        const { list } = this.state;
        if(list&&list.length>0){
            return {success:true,data: list};
        }else return {success:false}
    }
    /**
     * 重置页面
     * */
    resetList(fetchCondition){
        const {pagination} = this.state;
        this.setState({
            list: [],
            pagination:{
                ...pagination,
                total: 0,
                current:1
            },
            lastSearch:fetchCondition,
        })
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    /**
     * 处理栏目
     **/
    handleColumns(formatColumns){
        if(formatColumns&&formatColumns.constructor === Array){
            formatColumns.forEach((column,i) => {
                if(column.cnTitleId){
                    let titleStr ='';
                    if(column.cnTitleId.constructor===Array){
                        const list = column.cnTitleId;
                        list.forEach((item,index)=>titleStr += Lang({id: item, default: column.cnTitle[index]})+'/');
                        titleStr = titleStr.substr(0,titleStr.length-1);
                    }else titleStr = Lang({id: column.cnTitleId, default: column.cnTitle});
                    column.title =titleStr;
                }
                if(column.type&&column.type=='timestampToDate'){
                    column['render'] = (timestamp, record) => dayjs(timestamp).format('YYYY-MM-DD');
                }
                if(column.type&&column.type=='millisecondToTime'){
                    column['render'] =  (timestamp, record) => this.getSubmissionTime(timestamp);
                }
                if(column.type&&column.type=='money'){
                    column['render'] = (num, record) => {
                        if(!isEmpty(column.showSymbol)) return <span>{record[column.showSymbol]}<span className={"margin-left-5"}> {formatNumberToPrice(toFixed2(num||0),',',true)}</span></span>
                        return formatNumberToPrice(toFixed2(num),',',true);
                    }
                }
            })
        }
        return formatColumns;
    }
    setNewList(list=[],callback){
        this.setState({
            list:list,
            reload:true,
            loading:true,
        },()=>{
            this.setState({
                reload:false,
            })
            setTimeout(()=>{
                this.loading(false)
                if(callback)callback()
            },400)
        })
    }
    /**
     * 进入 加载数据 列表
     */
    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
        if(this.props.initFetch){
            let fetchCondition = {};
            if(this.props.fetchCondition)fetchCondition=this.props.fetchCondition;
            this.fetch(1,fetchCondition);
        }
    }
    render() {
        const { columns,paginationFlag, rowSelection} = this.props;
        const { loading, list, size, rowClassName, pagination,reload } = this.state;
        const components = {
            body: {
                row: EditableRow,
                cell: EditableCell,
            },
        };
        const editColumns = columns.map(col => {
            col = this.handleColumns(col)
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    editType:col.editType,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    required: col.required,
                    handleSave: this.handleSave,
                    // type: col.type,
                    // typeclass:col.typeclass,
                }),
            };
        });
        return (
            <div className={"essa-edit-table"}>
                {this.props.children}
                {!reload&&<Table
                    components={components}
                    rowKey={record => record.id}    // KEY
                    rowClassName={() => 'editable-row'}
                    bordered
                    dataSource={list}  // 数据源
                    columns={editColumns}
                    rowSelection={rowSelection}
                    pagination={paginationFlag?pagination:paginationFlag}         //页码
                    loading={loading}    //加载
                    onChange={this.handleTableChange} // 点击切换页码事件
                    scroll={this.props.scroll}
                    rowClassName= {rowClassName} //表格行的类名
                    size = {size}        //大小
                    footer={ this.props.footer}      //底部默认null
                />}
            </div>
        );
    }
}

export default EditTable;
